import { GetContent } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';
import { AppName } from '@lib/types';

export const GetContentApi =
  (endpoint: string): GetContent =>
  async ({ clubCode, campaignCode, region }) => {
    try {
      const url = `${endpoint}?clubCode=${clubCode}&appName=${AppName.MSS}&campaignCode=${campaignCode ?? ''}&region=${region}`;
      const config = createAxiosConfig(endpoint, true);
      delete config.headers?.['X-Request-Id']; //cors not allowed

      const response = await axios.get(url, config);

      LogCannon.blast('GetContentApi success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('GetContentApi error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'GetContentApi failed',
          ...errorResponse,
        },
      });
    }
  };
